import { HashAnchor } from 'components/HashAnchor';
import Checkbox from 'components/shared/Checkbox';
import { Controller, useFormContext } from 'react-hook-form';
import { FormCheckboxProps } from './FormCheckbox.types';

export const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  input = {}
}) => {
  const { control } = useFormContext();

  const onChangeHandler =
    input.onChange ||
    (() => {
      // NOOP
    });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div>
          <HashAnchor name={`anchor_${name}`} />
          <Checkbox
            id={name}
            aria-label={name}
            label={input.label || ''}
            {...input}
            {...field}
            checked={field.value}
            onChange={(e) => {
              field.onChange(e.currentTarget.checked);
              onChangeHandler(e);
            }}
          />
        </div>
      )}
    />
  );
};
